'use client'

import { ComponentProps } from 'react'

import ShoppingBasketModal from './ShoppingBasketModal'

export default function ShoppingBasket(props: ComponentProps<typeof ShoppingBasketModal>) {
  return props.isOpen ? <ShoppingBasketModal {...props} /> : null
}
